var map = {
  "./mobile/index.js": [
    "41061",
    9,
    "18178",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "17313",
    "10937",
    "31611",
    "87654"
  ],
  "./desktop/index.js": [
    "88833",
    9,
    "76225",
    "62815",
    "6063",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "17313",
    "10937",
    "31611",
    "73474"
  ],
  "./desktop/index": [
    "88833",
    9,
    "76225",
    "62815",
    "6063",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "17313",
    "10937",
    "31611",
    "73474"
  ],
  "./mobile/Pollopinions": [
    "59119",
    9,
    "3199",
    "10937",
    "49937"
  ],
  "./mobile/Pollopinions.js": [
    "59119",
    9,
    "3199",
    "10937",
    "49937"
  ],
  "./mobile": [
    "41061",
    9,
    "18178",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "17313",
    "10937",
    "31611",
    "87654"
  ],
  "./desktop/Pollopinions.js": [
    "57987",
    9,
    "3199",
    "10937",
    "59045"
  ],
  "./desktop": [
    "88833",
    9,
    "76225",
    "62815",
    "6063",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "17313",
    "10937",
    "31611",
    "73474"
  ],
  "./desktop/": [
    "88833",
    9,
    "76225",
    "62815",
    "6063",
    "47387",
    "3199",
    "50437",
    "21007",
    "45127",
    "92625",
    "74151",
    "52377",
    "17313",
    "10937",
    "31611",
    "73474"
  ],
  "./desktop/Pollopinions.scss": [
    "14669",
    7,
    "53526"
  ],
  "./mobile/": [
    "41061",
    9,
    "18178",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "17313",
    "10937",
    "31611",
    "87654"
  ],
  "./desktop/Pollopinions": [
    "57987",
    9,
    "3199",
    "10937",
    "59045"
  ],
  "./mobile/Pollopinions.scss": [
    "59803",
    7,
    "91602"
  ],
  "./mobile/index": [
    "41061",
    9,
    "18178",
    "47387",
    "3199",
    "6937",
    "38154",
    "17189",
    "17313",
    "10937",
    "31611",
    "87654"
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(function() {
      var e = new Error("Cannot find module '" + req + "'");
      e.code = 'MODULE_NOT_FOUND';
      throw e;
    });
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
    return __webpack_require__.t(id, ids[1] | 16);
  });
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 81383;
module.exports = __rspack_async_context;
